module.exports = __webpack_public_path__ + "static/img/dzp7.c3d0270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dzp7.png
// module id = tK8S
// module chunks = 1